export default __webpack_public_path__ + "static/media/DASHBOARD1.d5b21d81.webp";